export const warning = msg => {
  console.warn(msg)
}

export const error = msg => {
  console.error(msg)
}
